import type { AuthProvider } from '@refinedev/core'
import { flaskApi } from '@/lib/flaskApi'

let inMemoryToken: string | null = null

export const getPostgrestToken = () => inMemoryToken

export const authProvider: AuthProvider = {
  login: async ({ username, password }: { username: string; password: string }) => {
    try {
      const { data } = await flaskApi.post('/auth/login', { username, password })
      inMemoryToken = data.access_token
      return { success: true, redirectTo: '/' }
    } catch {
      return { success: false, error: { name: 'Login failed', message: 'Invalid username or password' } }
    }
  },

  logout: async () => {
    try {
      await flaskApi.post('/auth/logout')
    } catch {
      /* best-effort — session already invalid */
    }
    inMemoryToken = null
    return { success: true, redirectTo: '/login' }
  },

  check: async () => {
    try {
      await flaskApi.get('/auth/me')
      if (!inMemoryToken) {
        const { data } = await flaskApi.post('/auth/refresh')
        inMemoryToken = data.access_token
      }
      return { authenticated: true }
    } catch {
      inMemoryToken = null
      return { authenticated: false, redirectTo: '/login' }
    }
  },

  getPermissions: async () => null,

  getIdentity: async () => {
    const { data } = await flaskApi.get('/auth/me')
    return data
  },

  onError: async (error) => {
    if (error?.status === 401) {
      inMemoryToken = null
      return { logout: true }
    }
    return { error }
  },
}
